export enum EPesquisasDrawer {
  AntecipaPopUp = "AntecipaPopUp"
}

export interface ObterPesquisaDrawerResponse {
  nome: EPesquisasDrawer;
  ativo: boolean;
}

export interface IHttpPesquisasResponse<T> {
  code: number;
  result: T;
}

export interface PesquisaDrawerGateway {
  enviar(tipo: EPesquisasDrawer, content: unknown): Promise<boolean>;
  obterPesquisaDrawer(): Promise<
    IHttpPesquisasResponse<ObterPesquisaDrawerResponse[]> | undefined
  >;
}

export const PesquisaDrawerGatewayDi = Symbol("PesquisaDrawerGatewayDi");
